//Hauptseite footer

import React from "react"
import '../styles/footer.scss'
import GitHubIcon from '@mui/icons-material/GitHub';
import EmailIcon from '@mui/icons-material/Email';
import Button from "react-bootstrap/esm/Button";

const Footer = () => {
  return (
    <div className="section" id="contact">
      <div className="container">
        <div className="footer-container">
          <h1>Contact</h1>



    <a class="email-link" href="https://github.com/hx-ux">
    <Button variant="primary" class="primary-btn" size="lg" style={{width:"100%",height:"5em"}}><icon><GitHubIcon /></icon> GITHUB</Button>
    </a>

    <a class="email-link" href="">
    <Button variant="primary" size="lg" style={{width:"100%",height:"5em"}}><icon><EmailIcon /></icon> Email</Button>
    </a>
      
      <br></br>
        <h3>Made with React and 🐈</h3>
        </div>

      </div>
    </div>
  )
}

export default Footer
